<app-table [useFixedHeader]="true">
  <app-table-headers>
    <app-table-header class="flex-half picture-cell"></app-table-header>
    <app-table-header class="flex-double">Name</app-table-header>
    <app-table-header class="flex-double">Email</app-table-header>
    <app-table-header class="flex-double">ID</app-table-header>
    <ng-container *ngIf="accountUserSearch">
      <app-table-header class="flex"> Account </app-table-header>
      <app-table-header *ngIf="selectedPermissions.length" class="flex">
        <div class="row">
          <div class="col">
            <input
              type="checkbox"
              (click)="onSelectAll($event.target.checked)"
            />
            Select
          </div>
          <div class="col-auto">
            <button
              *ngIf="selectedUsers.length"
              (click)="editSelectedUsers.emit()"
              class="btn btn-primary btn-slim"
            >
              <i class="far fa-edit"></i>
            </button>
          </div>
        </div>
      </app-table-header>
    </ng-container>
  </app-table-headers>

  <ng-template #empty>
    <app-table-content-empty [isLoading]="isLoadingUsers">
      <ng-container loading><p>Fetching users ...</p></ng-container>

      <ng-container nodata *ngIf="!isLoadingUsers">
        <p><strong *ngIf="!users">Enter search word to find users</strong></p>

        <p *ngIf="users && !users.length">No users found</p>
      </ng-container>
    </app-table-content-empty>
  </ng-template>

  <app-table-content
    *ngIf="!isLoadingUsers && users && users.length; else empty"
  >
    <app-table-row *ngFor="let user of users">
      <app-table-cell class="flex-half picture-cell">
        <img [src]="user.picture" width="50px" height="50px" />
      </app-table-cell>
      <app-table-cell class="flex-double">
        <a (click)="goTo(user)">
          <strong>{{ user.name }}</strong>
        </a>
      </app-table-cell>
      <app-table-cell class="flex-double">{{ user.email }}</app-table-cell>
      <app-table-cell class="flex-double">{{ user.userId }}</app-table-cell>
      <ng-container *ngIf="accountUserSearch">
        <app-table-cell class="flex">
          {{ user.accountId }}
        </app-table-cell>
        <app-table-cell
          *ngIf="selectedPermissions.length"
          class="flex"
          (click)="toggleUserToSelected(user)"
        >
          <input
            type="checkbox"
            [checked]="isUserChecked(user.userId, user.accountId)"
          />
        </app-table-cell>
      </ng-container>
    </app-table-row>
  </app-table-content>
</app-table>
